import React from 'react'
import Logo from '../../paginas/img/logo_fondo_negro.png'
import Avatar from '../../paginas/img/avatar.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPowerOff, faBell } from '@fortawesome/free-solid-svg-icons'
import {
    MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavbarToggler, MDBCollapse, MDBFormInline, MDBHamburgerToggler,
} from "mdbreact";

import { ReactComponent as LeftLogo } from '../../paginas/icons/left.svg';
import { ReactComponent as SearchLogo } from '../../paginas/icons/search.svg';
import { ReactComponent as CodigoQRLogo } from '../../paginas/icons/codeqr.svg';
import { useNavigate } from 'react-router-dom'



const PosMenuEscritorio = (props) => {
    const navigate = useNavigate()
    const { irAdmin, cerrarSesion, cierre, cambiarBuscador, cambiarCodigoBarras, cookies, colorNotificacion, textoNotificacion, Estado, className } = props
    return (
        <MDBNavbar color="white" expand="md" light className={`${className} menu-pos`}>
            <MDBNavbarBrand className="container_atras">
                <button onClick={irAdmin} className="btn_atras">
                    <LeftLogo fill="#834598" width={20} height={20} />
                </button>
            </MDBNavbarBrand>
            <MDBNavbarBrand>
                <img src={Logo} className="logoMenu" />
            </MDBNavbarBrand>

            <MDBNavbarNav right>
                <MDBNavItem>
                    <div className="search-icons" onClick={cambiarBuscador}>
                        <SearchLogo fill="#834598" width={25} height={25} />
                    </div>
                </MDBNavItem>
                <MDBNavItem>
                    <div className="codeqr-icons" onClick={cambiarCodigoBarras}>
                        <CodigoQRLogo width={25} height={25} />
                    </div>
                </MDBNavItem>
                <MDBNavItem>
                    {Estado() !== '' ?
                        <div className={`${colorNotificacion} notificacion`} onClick={() => navigate('/Admin', {
                            state: {
                                url: 'Inventario',
                            }
                        })}>
                            <span><FontAwesomeIcon icon={faBell} size="1x" /> Inventarios {textoNotificacion}</span>
                        </div>

                        : null}

                </MDBNavItem>
                <MDBNavItem>
                    {cierre === 'cerrado' ?
                        <div className="estado_caja_cerrada">
                            <span>Caja Cerrada</span>
                        </div>
                        : null}
                    {cierre === 'abierto' ?
                        <div className="estado_caja">
                            <span>Caja Abierta</span>
                        </div>

                        : null}

                </MDBNavItem>
                <MDBNavItem>
                    <button className="cerrarMenu" onClick={cerrarSesion}>
                        <span><FontAwesomeIcon icon={faPowerOff} size="1x" /> Cerrar</span>
                    </button>
                </MDBNavItem>
                <MDBNavItem>
                    <div className='d-flex align-items-center h-100'>
                        <div className="usuarioMenu">
                            <span> {cookies.get('nombre')} </span>
                            <div><img src={Avatar} /></div>
                        </div>
                    </div>

                </MDBNavItem>
            </MDBNavbarNav>

        </MDBNavbar>)
}

export default PosMenuEscritorio